angular.module('SpidApp')

.factory('Mailer', ['SyncConfig', '$http', function (SyncConfig, $http) {
    var Mailer = function (params) {
        params = params || {}
        
        this._distantUrl           = SyncConfig.Distant.getURLFor('/mailer')
        this._distantAuthorization = SyncConfig.Distant.Authorization
        
        this.to             = params.to
        this.subject        = params.subject
        this.message        = params.message
        this.name           = params.name
    }
    
    Mailer.prototype.setTo      = function (to)      { this.to      = to      }
    Mailer.prototype.setSubject = function (subject) { this.subject = subject }
    Mailer.prototype.setMessage = function (message) { this.message = message }
    Mailer.prototype.setName = function (name) { this.name = name }
    
    Mailer.prototype.send = function () {
        var auth = this._distantAuthorization
        var url  = this._distantUrl
        
        if (!this.to || !this.subject || !this.message) {
            throw 'Mailer::send() - Refused to send email'
        }
        
        var to      = this.to
        var subject = this.subject
        var message = this.message
        var name = this.name
        
        var req = {
              method: 'POST'
            , url: url
            , headers: {
                'Authorization': auth
            }
            , data: {
                  to     : to
                , subject: subject
                , message: message
                , name : name
            }
        }
        
        return $http(req).then(function (response) {
            return response.data
        })
    }
    
    return Mailer
}])
